import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShowListPageComponent } from './components/show-list-page/show-list-page.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { SeriesChannelPageComponent } from './components/series-channel-page/series-channel-page.component';
import { WhereToWatchPageComponent } from './components/where-to-watch-page/where-to-watch-page.component';
import { MovieSpherePlusPageComponent } from './components/movie-sphere-plus-page/movie-sphere-plus-page.component';
import { AuthGuard } from './guard/auth.guard';
import { CmsLoginComponent } from './components/cms/cms-login/cms-login.component';


const routes: Routes = [
    { path: '', component: HomePageComponent, data: { animation: 'page' } },
    { path: 'where-to-watch', component: WhereToWatchPageComponent, data: { animation: 'page' } },
    { path: 'movie-sphere', component: ShowListPageComponent, data: { animation: 'page' } },
    { path: 'movie-sphere-plus', redirectTo: 'moviesphere-plus', pathMatch: 'full' },
    { path: 'moviesphere-plus', component: MovieSpherePlusPageComponent, data: { animation: 'page' } },
    { path: 'outer-sphere', component: ShowListPageComponent, data: { animation: 'page' } },
    { path: 'her-sphere', component: ShowListPageComponent, data: { animation: 'page' } },
    { path: 'ebonytv', component: ShowListPageComponent, data: { animation: 'page' } },
    { path: '50centaction', component: ShowListPageComponent, data: { animation: 'page' } },
    { path: 'lawless', component: ShowListPageComponent, data: { animation: 'page' } },
    { path: 'extreme-jobs', component: ShowListPageComponent, data: { animation: 'page' } },
    { path: 'channel/:id', component: SeriesChannelPageComponent, data: { animation: 'page' } },
    { path: 'channel/:id', component: SeriesChannelPageComponent, data: { animation: 'page' } },
    { path: 'cms', component: HomePageComponent, canActivate: [AuthGuard], data: {animation: 'page'},   },
    { path: 'cms-login', component: CmsLoginComponent, data: { animation: 'page' } },
]

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        // initialNavigation: 'enabledBlocking',
        scrollPositionRestoration: 'top'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
